import { render } from "./MarketplaceAuthorDetails.vue?vue&type=template&id=56c4b3e7&lang=html"
import script from "./MarketplaceAuthorDetails.vue?vue&type=script&lang=js"
export * from "./MarketplaceAuthorDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__